import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../../configureStore';

const selectUsersState = (state: RootState) => state.users;

const selectUsers = createDraftSafeSelector(selectUsersState, (state) => state.users);

const selectSearchEmail = createDraftSafeSelector(selectUsersState, (state) => state.searchEmail);

const selectSort = createDraftSafeSelector(selectUsersState, (state) => state.sort);

export { selectUsersState, selectUsers, selectSearchEmail, selectSort };
